import React from "react";
import Media from "react-media";
import { withTheme } from "glamorous";
import { Button } from "../../../../common/components";

const OnboardingNavigation = ({
  submitOnNext,
  activeIndex,
  steps,
  currentStep,
  goForward,
  goBack,
  theme: { colors }
}) => {
  const navButtonProps = {
    backgroundColor: colors[currentStep.color],
    transition: "background-color 1s ease",
    flexGrow: 1
  };
  return (
    <Media query="(max-width: 425px)" key="customNav">
      {isPhone => {
        return (
          <div style={{ marginTop: "2rem", textAlign: "center" }}>
            <Button
              icon="arrow_back"
              label={isPhone ? undefined : "previous"}
              style={{
                ...navButtonProps,
                visibility: activeIndex > 1 ? "visible" : "hidden",
                width: "125px"
              }}
              onClick={goBack}
            />
            <span>&nbsp;&nbsp;</span>
            <Button
              icon="arrow_forward"
              iconPlacement="right"
              label={isPhone ? undefined : "next"}
              style={{
                ...navButtonProps,
                visibility:
                  activeIndex < steps.length - 1 ? "visible" : "hidden",
                  width: "125px"
              }}
              onClick={goForward}
              type={submitOnNext ? "submit" : "button"}
            />
          </div>
        );
      }}
    </Media>
  );
};

export default withTheme(OnboardingNavigation);



// WEBPACK FOOTER //
// ./src/App/account/components/Onboarding/OnboardingNavigation.js